import { useTranslation } from 'react-i18next';
import { SummaryProps } from '../../Summary.model';
import { SummaryAncillaries } from '../summary-ancillaries/SummaryAncillaries';
import { SummaryOthers } from '../summary-others/SummaryOthers';
import { SummaryTotal } from '../summary-total/SummaryTotal';
import { SummaryTrips } from '../summary-trips/SummaryTrips';
import { SummaryPassengers } from '../summary-passengers/SummaryPassengers';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const SummaryItems = (props: SummaryProps) => {
	const { t } = useTranslation('summary');
	const {
		trips,
		isMultiTrip,
		passengers,
		ancillaries,
		otherItems,
		onholdPrice,
		avios,
		totalPrice,
		totalDcc,
		upgradingBid,
		collapsed
	} = props;
	return (
		<ErrorBoundaryProvider>
			{/* TRIPS */}
			<SummaryTrips isMultiTrip={isMultiTrip} trips={trips} collapsed={collapsed ?? false} />
			{/* PASSENGERS */}
			<SummaryPassengers passengers={passengers} />
			{/* ANCILLARIES */}
			<SummaryAncillaries ancillaries={ancillaries} />
			{/* OTHER ITEMS */}
			<SummaryOthers otherItems={otherItems} />
			{/* TOTAL */}
			<SummaryTotal
				title={upgradingBid ? t('MAX_TO_PAY') : t('TOTAL')}
				subtitle={(upgradingBid && t('UPGRADING_BIDS_PAYMENT')) || (onholdPrice && t('TOTAL_ONHOLD_SUBTITLE'))}
				dccTitle={t('FINAL_PRICE')}
				price={onholdPrice || totalPrice}
				avios={avios}
				dccPrice={totalDcc}
			></SummaryTotal>
		</ErrorBoundaryProvider>
	);
};
